const API_BASE_URL = process.env.BASE_URL

export const REPORTS_ENDPOINTS = {
    DATA: API_BASE_URL + "/{service_company_slug}/api/reports/data/",
    DASHBOARDS: API_BASE_URL + "/{service_company_slug}/api/reports/dashboards/",
}
